export default "__VITE_ASSET__Bcy_V$oG__"